<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  export default {
    name: 'App',
    data() {
      return {
        proxy: null,
        sendState: false,
        themeList: [{
          id: 1,
          name: '默认颜色',
          code: 'default'
        }, {
          id: 2,
          name: '炫酷蓝色',
          code: 'blue'
        }]
      }
    },
    created() {

      let _this = this;
      _this.getAdminData();

    },
    computed: {
      CodeValue() {
        let _this = this;
        return _this.$store.getters.getCodeValue;
      },
      DeviceUnfold() {
        let _this = this;
        return _this.$store.getters.getDeviceUnfold;
      }
    },
    watch: {
      CodeValue(value) {
        let _this = this;
        if (value) {
          _this.connectServer(value);
        }
      },
      DeviceUnfold(value) {
        let _this = this;
        if (value) {
          if (_this.sendState) {
            _this.sendDeviceCodes(value);
          }
        } else {
          // 取消设备推送
          _this.unSendDeviceCodes();
        }
      }
    },
    mounted() {},
    methods: {
      getAdminData() {

        if (!Cookies.get('AdminData')) {
          return;
        }

        let _this = this

        if (!_this.$store.getters.getCodeValue) {
          let AdminData = JSON.parse(Cookies.get('AdminData'));
          _this.$store.dispatch("setCodeValue", `${AdminData.GroupCode}${AdminData.CompanyCode}${AdminData.DepartmentCode}`);
        }

      },

      // SignalR
      connectServer(value) {
        let _this = this;
        let conn = $.hubConnection("http://yhj.hxpwr.com/signalr/hubs", {
          useDefaultPath: false
        })
        _this.proxy = conn.createHubProxy("HomeHub");
        _this.proxy.on("SendBjCount", (data) => {
          if (data) {
            _this.$store.dispatch("setSignalRState", true);
            _this.$store.dispatch("setDeviceAlarm", JSON.parse(data));
          }
        })
        _this.proxy.on("SendMessage", (DeviceCode, datetime, devicestatus, kaiguanStatus) => {
          _this.$store.dispatch("setDeviceStates", {
            DeviceCode,
            datetime,
            devicestatus,
            kaiguanStatus
          });
        })
        conn.start().done((data) => {
          _this.proxy.invoke("sendLogin", value).done((msg) => {
            console.log('对接成功^v^');
            _this.sendState = true;
          });
        }).fail((data) => {
          console.log('对接失败！')
        });
      },

      // 设备监听状态
      sendDeviceCodes(value) {
        let _this = this;

        if (_this.CodeValue) {
          _this.proxy.invoke("sendDeviceCodes", `${_this.CodeValue}@${value}`).done((msg) => {
            console.log('设备连接成功！');
          });
        }

      },

      // 取消设备监听
      unSendDeviceCodes() {
        let _this = this;

        _this.proxy.invoke("unSendDeviceCodes", `${_this.CodeValue}`).done((msg) => {
          console.log('取消连接成功！');
        });
      },
    },
  }

</script>

<style>
  html,
  body {
    margin: 0;
    padding: 0;
  }

  /*去除百度地图版权*/
  .anchorBL {
    display: none;
  }

  .tangram-suggestion-main {
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue